import React from 'react';

import { StyledTooltip } from 'styles/common';

import { ChevronRightIcon, StyledIconV2 } from 'constants/icons';

const RightArrowIcon = ({ className, onClick }) => (
  <StyledTooltip className={className} title="Open Details Panel">
    <StyledIconV2
      size="fixed10px"
      containerSize="fixed24px"
      circularOutline
      color="primary"
      bgColor="white"
      style={{ flex: '0 0 auto' }}
      rightGutter={1}
      onClick={onClick}
    >
      <ChevronRightIcon size="fixed10px" />
    </StyledIconV2>
  </StyledTooltip>
);

export { RightArrowIcon };
